<form [formGroup]="form" novalidate autocomplete="off">
  <div class="modal-dialog-header">
    <button
      type="button"
      tabindex="-1"
      class="close float-right"
      data-dismiss="modal"
      aria-label="Close"
      (click)="cancel()"
      title="Close form and discard any changes."
    >
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
    <h3 mat-dialog-title>Transfer Cart Items to Site</h3>
  </div>
  <mat-dialog-content class="modal-dialog-content">
    <div class="form-group">
      <label for="siteId">Target Site</label>
      <select formControlName="siteId" class="form-control form-control-sm">
        <option [ngValue]="null"></option>
        <option *ngFor="let site of data.sites" [ngValue]="site.id">{{ site.name }}</option>
      </select>
      <p *ngIf="form.get('siteId').invalid && form.get('siteId').dirty" class="text-danger">
        A target site is required
      </p>
    </div>
    <div class="form-group">
      <div class="operation-details">
        <p>This operation will:</p>
        <ul>
          <li>Create new buildings in the target site with the same names as the source buildings</li>
          <li>Create new rooms in the new buildings with the same names as the source rooms</li>
          <li>Update all items in the cart to reference the new buildings and rooms</li>
        </ul>
        <p><strong>Note:</strong> If a building or room with the same name already exists in the target site, it will be reused.</p>
      </div>
    </div>
  </mat-dialog-content>
  <div class="modal-dialog-footer">
    <button type="button" class="btn btn-default float-left btn-sm" (click)="cancel()">
      <fa-icon [icon]="faTimes"></fa-icon> Cancel
    </button>
    <button type="button" (submitIfValid)="save()" [form]="form" class="btn btn-primary float-right btn-sm">
      <fa-icon [icon]="faSave"></fa-icon> Transfer
    </button>
  </div>
</form> 